module.exports = __webpack_public_path__ + "content/61a619fa0c5c8958c658523080c5f889.png";